<template>
    <div>
        <!-- <div v-show="ongoingTour" class="w-screen h-screen bg-indigo-600 opacity-25 z-30 absolute custom-clip"></div> -->
        <!-- ONBOARDING DASHBOARD -->
        <!-- <neopass-tour
            v-show="currentPage === '/' && onBoarding.tourDashboard === true"
            name="tourDashboard"
            :steps="onboardingConstants.DASHBOARD_STEPS"
            :tourCallbacks="tourCallbacks"
        /> -->

        <!--ONBOARDING neopass-->
        <neopass-tour
            v-show="currentPage === '/neopass' && onBoarding.tourNeopass === true"
            name="tourNeopass"
            :steps="stepsNeopass"
            @tourSkipped="tourSkipped()"
            @tourFinished="tourFinished()"
        />

        <!-- ONBOARDING neopass form -->
        <neopass-tour
            v-show="/\/form\/neopass\/[0-9]*/.test(currentPage) && onBoarding.tourNeopassForm === true"
            name="tourNeopassForm"
            :steps="stepsNeopassForm"
            @tourSkipped="tourSkipped()"
            @tourFinished="tourFinished()"
        />

        <!-- ONBOARDING MODELE -->
        <neopass-tour
            v-show="/modeles-de-page/.test(currentPage) && onBoarding.tourModele === true"
            name="tourModele"
            :steps="stepsModele"
            @tourSkipped="tourSkipped()"
            @tourFinished="tourFinished()"
        />


        <!-- ONBOARDING BIBLIOTHEQUE PERSO -->
        <neopass-tour
            v-show="currentPage === '/fiches-de-poste' && onBoarding.tourBibliperso === true && personalLibrary === true"
            name="tourBibliperso"
            :steps="stepsBibliperso"
            @tourSkipped="tourSkipped()"
            @tourFinished="tourFinished()"
        />

        <!-- ONBOARDING BIBLIOTHEQUE COMMUNE -->
        <neopass-tour
            v-show="currentPage === '/fiches-de-poste' && onBoarding.tourBiblicommune === true && personalLibrary === false"
            name="tourBiblicommune"
            :steps="stepsBiblicommune"
            @tourSkipped="tourSkipped()"
            @tourFinished="tourFinished()"
        />

        <!-- ONBOARDING CARTOS -->
        <!-- <neopass-tour
            v-show="currentPage === '/cartographies/collectives/informations' && onBoarding.tourCartographie === true"
            name="tourCartographie"
            :steps="onboardingConstants.CARTOGRAPHIES_INDIVIDUELLES_STEPS"
            :tourCallbacks="tourCallbacks"
        /> -->
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import axios from "./../../api";
import NeopassTour from "./NeopassTour.vue";
import Constants from "./../../constants";

export default {
    components:{
        NeopassTour,
    },

    props:{
        currentPage: String,
    },

    data(){
        return {
            constants: Constants,
            stepsDashboard: [
                /*
                {
                    target: '.tour_searchbar',
                    header: {
                        title: 'Barre de Recherche',
                    },
                    content: `Recherchez tout type de données dans l'application Neopass.`,
                    params: {
                        placement: 'bottom',

                    }
                },
                */

                /*
                {
                    target: '.tour_messages',
                    header: {
                        title: 'Messagerie',
                    },
                    content: 'Accedez à votre messagerie en ligne <br> afin de discuter avec vos collaborateurs.',
                    params: {
                        placement: 'bottom',

                    }
                },
                */
                /*
                {
                    target: '.tour_notifs',
                    header: {
                        title: 'Notifications',
                    },
                    content: 'Consultez vos notifications <br> (rappel de dates, tags, partages...',
                    params: {
                        placement: 'bottom',

                    }
                },
                */
                /*
                {
                    target: '.tour_customizedashboard',
                    header: {
                        title: 'Tableau de bord',
                    },
                    content: 'Personnalisez l\'affichage de vos modules',
                    params: {
                        placement: 'top',

                    }
                }
                */
            ],

            stepsNeopass: [
                {
                    target: '#tour_add_neopass',
                    header: {title: 'Ajout de Carnet',},
                    content: `Créez un nouveau carnet de parcours ou ajoutez un carnet de parcours existant.`,
                    params: {placement: 'right', enableScrolling: false},
                    perm: this.$can(Constants.PERMISSION_NEOPASS_AJOUTER_BENEFICIAIRE),
                },
                {
                    target: '#tour_filter_name',
                    header: {title: 'Rechercher un bénéficiaire',},
                    content: "Saisissez le nom et/ou prénom d'un bénéficiaire pour le retrouver dans la liste",
                    params: {placement: 'left', enableScrolling: false},
                    perm: true
                },
                {
                    target: '#tour_sort_date',
                    header: {title: 'Tri alphabétique ou chronologique',},
                    content: 'Triez les carnets de parcours par dates de mise à jour de façon chronologique ou antichronologique, ou par ordre alphabétique ou anti-alphabétique.',
                    params: {placement: 'left', enableScrolling: false},
                    perm: true
                },
                {
                    target: '.tour_quick_actions',
                    header: {title: 'Action rapides',},
                    content: 'Accédez rapidement à certaines fonctionnalités telles que la cartographie ou encore l\'impression du Neopass.',
                    params: {placement: 'top', enableScrolling: false},
                    perm: this.$can(Constants.PERMISSION_NEOPASS_EXPORT) || this.$can('neopass_rights') || this.$can(Constants.PERMISSION_NEOPASS_DETACHER) || this.$can('individuelles')
                }
            ],

            stepsNeopassForm: [
                {
                    target: '#tour_menu_neopass',
                    header: {title: 'Menu carnet de parcours',},
                    content: 'Accédez aux différents onglets du Neopass, afin de remplir les formulaires et les évaluations.',
                    params: {placement: 'right' , highlight: true, enableScrolling: false},
                    perm: true
                },
                {
                    target: '.tour_quick_actions',
                    header: {title: 'Boutons accès rapide',},
                    content: 'Imprimez, exportez et accédez aux cartographies en un clic.',
                    params: {placement: 'top', enableScrolling: false},
                    perm: (this.$can(Constants.PERMISSION_NEOPASS_EXPORT) || this.$can(Constants.PERMISSION_CARTOGRAPHIE_INDIVIDUELLE_DISPLAY) || this.$can('neopass_form_historic')),
                },
                {
                    target: '.tour_progress_bar',
                    header: {title: 'Barre de progression',},
                    content: 'Suivez l\'état d\'avancement du remplissage de formulaire que vous effectuez. Au début la barre est complètement vide, puis elle se remplit au fur et à mesure de l\'avancement de la tâche pour finir complètement remplie lorsque le remplissage est terminé.',
                    params: {placement: 'bottom', enableScrolling: false},
                    perm: true
                },
                {
                    target: '#tour_save_datas',
                    header: {title: 'Bouton de sauvegarde',},
                    content: 'Sauvegardez les modifications que vous effectuez. Si vous fermez ou changez de page sans avoir sauvegardé, vos modifications ne seront pas prises en compte.',
                    params: {placement: 'right', enableScrolling: false},
                    perm: this.$can(((((this.$route.path.split('/form/neopass/') || [])[1] || '').split('/') || [])[2] || '')+'_edit')
                }
            ],

            stepsModele: [
                {
                    target: '#tour_add_modele',
                    header: {
                        title: 'Ajouter une nouvelle page',
                    },
                    content: 'Vous pouvez ajouter une nouvelle page de Neopass et personnaliser le contenu comme vous le souhaitez.',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                        enableScrolling: false
                    },
                    perm: this.$can(Constants.PERMISSION_MODELE_DE_PAGE_AJOUTER_MODELE)
                },
                {
                    target: '#tour_visualiser',
                    header: {
                        title: 'Visualiser le modèle',
                    },
                    content: 'Vous pouvez à tout moment visualiser votre modèle en cours de construction.',
                    params: {
                        placement: 'top',
                        enableScrolling: false
                    },
                    perm: this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER)
                }
            ],

            stepsBibliperso: [
                {
                    target: '.tour_fiches_postes_filtrer',
                    header: {
                        title: 'Filtrer',
                    },
                    content: 'Afin de faciliter vos recherches de fiches de poste, vous pouvez les filtrer par familles professionnelles ou secteurs d\'activités.',
                    params: {
                        placement: 'right',
                        enableScrolling: false
                    },
                    perm: true
                }
            ],

            stepsBiblicommune: [
                {
                    target: '#tour_add_personal_library',
                    header: {
                        title: 'Ajouter à ma bibliothèque personnelle',
                    },
                    content: 'Ajoutez à votre bibliothèque personnelle les fiches de poste déjà crées. Vous pourrez ensuite les personnaliser.',
                    params: {
                        placement: 'left',
                        enableScrolling: false
                    },
                    perm: this.$can(Constants.PERMISSION_FICHE_DE_POSTE_COMMUNE_AJOUTER_DANS_BIBLIOTHEQUE_PERSONNELLE)
                },
            ],

            stepsCartographie: [
                /* {
                    target: '.tour_carto_print',
                    header: {
                        title: 'Impression de Cartographies',
                    },
                    content: 'Imprimez vos cartographies afin de les inclure à vos bilans et rapports.',
                    params: {
                        placement: 'left',

                    }
                }, */
                {
                    target: '.tour_comparer_carto',
                    header: {
                        title: 'Comparaison de Cartographies',
                    },
                    content: 'Enregistrez vos cartographies à différentes dates afin de comparer les évolutions.',
                    params: {
                        placement: 'bottom',
                        enableScrolling: false
                    }
                },
            ],

            currentTour: '',
            ongoingTour: false,

            bibCommuneOnlyOnce: false,
            lastPage: '',
        }
    },

    methods:{
        launchOnboarding(){
            console.log("launchOnboarding");
            if (this.currentPage === '/fiches-de-poste' && this.personalLibrary === false && this.bibCommuneOnlyOnce === false && this.onBoarding.tourBiblicommune){
                axios.get('api/onboarding/temp/tourBiblicommune').then((response) => {
                    if (response.data == true){
                        this.filterSteps();
                        if (this.stepsBiblicommune.length === 0) return;
                        this.$tours['tourBiblicommune'].start();
                        this.ongoingTour = true;
                        this.currentTour = 'tourBiblicommune';
                        this.bibCommuneOnlyOnce = true;
                    }
                })
            }
            if (this.lastPage != this.currentPage){
                this.lastPage = this.currentPage;
                this.startOnboarding();
            }
        },

        async startOnboarding(){
            console.log('start onboarding')
            await this.filterSteps();

            if (this.currentPage === '/' && this.onBoarding.tourDashboard === true){
                await axios.get('api/onboarding/temp/tourDashboard').then((response) => {
                    if (response.data == true){
                        //this.$tours['tourDashboard'].start();
                    }
                })
            }
            else if(this.currentPage === '/neopass' && this.onBoarding.tourNeopass === true){
                await axios.get('api/onboarding/temp/tourNeopass').then((response) => {
                    if (response.data == true){
                        this.$tours['tourNeopass'].start();
                        this.ongoingTour = true;
                        this.currentTour = 'tourNeopass'
                    }
                })
            }
            else if(/\/form\/neopass\/[0-9]*/.test(this.currentPage) && this.onBoarding.tourNeopassForm === true){
                console.log("start onboarding in form neopass");
                await axios.get('api/onboarding/temp/tourNeopassForm').then((response) => {
                    console.log("is : "+response.data);
                    if (response.data == true){
                        this.$tours['tourNeopassForm'].start();
                        this.ongoingTour = true;
                        this.currentTour = 'tourNeopassForm'
                    }
                })
            }
            else if(/modeles-de-page/.test(this.currentPage) && this.onBoarding.tourModele === true){
                await axios.get('api/onboarding/temp/tourModele').then((response) => {
                    if (response.data == true && (this.$can(Constants.PERMISSION_MODELE_DE_PAGE_EDITER) || this.$can(Constants.PERMISSION_MODELE_DE_PAGE_AJOUTER_MODELE))){
                        this.$tours['tourModele'].start();
                        this.ongoingTour = true;
                        this.currentTour = 'tourModele'
                    }
                })
            }
            else if (this.currentPage === '/fiches-de-poste' && this.onBoarding.tourBibliperso === true && this.personalLibrary === true){
                await axios.get('api/onboarding/temp/tourBibliperso').then((response) => {
                    if (response.data == true){
                        this.$tours['tourBibliperso'].start();
                        this.ongoingTour = true;
                        this.currentTour = 'tourBibliperso'
                    }
                })
            }
            else if (this.currentPage === '/cartographies/collectives/informations' && this.onBoarding.tourCartographie === true){
                await axios.get('api/onboarding/temp/tourCartographie').then((response) => {
                    if (response.data == true){
                        /* Waiting to have print and compare function
                        this.$tours['tourCartographie'].start();
                        this.currentTour = 'tourCartographie' */
                    }
                })
            }
        },

        async filterSteps() {
            //Filter steps for elements that don't appear out of the array
            if (this.currentPage === '/neopass' && this.onBoarding.tourNeopass === true){
                this.stepsNeopass = this.stepsNeopass.filter(step => step.perm === true);
                await axios.get("/api/neopass").then((response) => {
                    if(response.data === false){
                        this.$router.push('/not-allowed');
                    }
                    else if(response.data){
                        if (response.data.length === 0){
                            this.stepsNeopass = this.stepsNeopass.filter(step => step.target !== '.tour_quick_actions');
                        };
                    }
                    else{
                        this.$router.push('/form/neopass/' + response.data.id);
                    }
                }).catch(error => {
                    console.log("ERRRR:: ", error);
                })
            }
            else if(/\/form\/neopass\/[0-9]*/.test(this.currentPage) && this.onBoarding.tourNeopassForm === true){
                this.stepsNeopassForm = this.stepsNeopassForm.filter(step => step.perm === true);
            }
            else if(/modeles-de-page/.test(this.currentPage) && this.onBoarding.tourModele === true){
                this.stepsModele = this.stepsModele.filter(step => step.perm === true);
            }
            else if (this.currentPage === '/fiches-de-poste' && this.onBoarding.tourBibliperso === true && this.personalLibrary){
                this.stepsBibliperso = this.stepsBibliperso.filter(step => step.perm === true);
            }
            else if (this.currentPage === '/fiches-de-poste' && this.onBoarding.tourBiblicommune === true && !this.personalLibrary){
                this.stepsBiblicommune = this.stepsBiblicommune.filter(step => step.perm === true);
            }
        },

        tourFinished(){
            this.ongoingTour = false;

            var checkbox = document.querySelector('#stop_showing_tour');

            if (checkbox.checked){
                let finishedTour = this.currentTour;
                axios.get("/api/onboarding/stop-showing/"+finishedTour).then((response) => {

                }).catch(error => {
                    console.log("ERRRR:: ", error);
                })
            }
            else {
                this.disableOnboardingTemp(this.currentTour);
            }
        },

        tourSkipped(){
            this.ongoingTour = false;

            this.disableOnboardingTemp(this.currentTour);
        },

        async disableOnboardingTemp(name){
            await axios.put('/api/onboarding/temp/'+name).then((response) => {

            }).catch(error => console.log('ERRR::', error))
        },
    },

    computed:{
        ...mapGetters({
            user: "auth/user",
            personalLibrary: "jobDescription/personalLibrary"
        }),

        onBoarding: {
            get() {
                return this.user.onboarding;
            },
            set(newValue) {
                this.user.onboarding = newValue;
            }
        },
    }
}
</script>

<style>
.custom-clip{
    /*clip-path: polygon(0 0, 0% 100%, 25% 100%, 25% 25%, 75% 25%, 75% 75%, 25% 75%, 25% 100%, 100% 100%, 100% 0%);*/
}
</style>
